import { useLanguage } from '../../contexts/LanguageContext';
import { useData } from '../../contexts/DataContext';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

const VisionMobile = () => {
  const { t } = useTranslation();
  const { language } = useLanguage();
  const result = useData();
  const vision = result.data.vision;
  const mission = result.data.mission;

  return (
    <div className="py-16 bg-gray-900 text-white">
      <div className="container px-6 mx-auto">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2">
          {/* Vision Card */}
          <motion.div 
            whileHover={{ scale: 1.02 }}
            className="p-10 bg-gray-800 rounded-xl shadow-lg relative overflow-hidden"
            data-aos="fade-right"
          >
            <h3 className="mb-4 text-3xl font-semibold">{vision.title}</h3>
            <p className="mb-6 leading-relaxed opacity-80">{vision.description}</p>
            {vision.image && (
              <img 
                src={vision.image}
                alt="Vision" 
                className="w-full rounded-lg mt-4 shadow-md"
              />
            )}
          </motion.div>

          {/* Mission Card */}
          <motion.div 
            whileHover={{ scale: 1.02 }}
            className="p-10 bg-gray-700 rounded-xl shadow-lg relative overflow-hidden"
            data-aos="fade-left"
          >
            <h3 className="mb-4 text-3xl font-semibold">{mission.title}</h3>
            <p className="mb-6 leading-relaxed opacity-90">{mission.description}</p>
            {mission.image && (
              <img 
                src={mission.image} 
                alt="Mission" 
                className="w-full rounded-lg mt-4 shadow-md"
              />
            )}
          </motion.div>
        </div>
      </div>
    </div>
  );
};
export default VisionMobile;